const state = {
  authCode: localStorage.getItem('authCode') ? localStorage.getItem('authCode').split(',') : [],
};

const mutations = {
  SET_AUTHCODE: (state, authCode) => {
    state.authCode = authCode;
    localStorage.setItem('authCode', authCode.join(','));
  },
};

const actions = {
  setAuthCode({ commit }, authCode) {
    commit('SET_AUTHCODE', authCode);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
